angular.module("ricercaUtenza.components", [])
  .component("ricercaUtenza", {
    templateUrl: 'ng/components/ricercaUtenza/ricercaUtenza.html',
    bindings: { userTypes: '<', userTypesPending: '<', configObj: '=', customerList: '<', searchCustomers: '&' },
    controller: RicercaUtenzaController,
    controllerAs: 'ricercaUtenzaCtrl'
  })

function RicercaUtenzaController(
  $configService,
  $typeDomainService,
  $rootScope,
  $simulationService
) {
  var self = this;

  self.$onInit = function () {
    self.researchObjAraVariable = {
      listTypeUser: [],
      listSubtypeUser: [],
      listStatusUser: [],
      piva: null,
      name: null,
      ndg: null,
      identifier: null,
      limit: "10",
      offset: 0,
      pageIndex: 1,
      totalPages: 0
    };
    self.initialTabIndex = $configService.getAppConfig().allFunctionalities.includes("CENSIMENTO_UTENZE") ? 8 : 1
    getStatus()
  }

  var getStatus = function () {
    self.restPending = true
    $typeDomainService
      .getDomainSet('APP_VENDOR_USER', 'TYPE')
      .then(function (response) {
        self.listStatus = response.domainList
        console.log('listStatus', self.listStatus)
        self.restPending = false;
      })
      .catch(function (err) {
        console.log(err);
        self.restPending = false;
      })
  }

  self.selectElements = function (value, property) {
    switch (property) {
      case "userType":
        self.researchObjAraVariable.listTypeUser = []
        self.researchObjAraVariable.listSubtypeUser = []
        value.forEach(function (user) {
          var userValue = user.value.split(";")
          self.researchObjAraVariable.listTypeUser.push(userValue[0]);
          self.researchObjAraVariable.listSubtypeUser.push(userValue[1]);
        })
        break;
      case "status":
        self.researchObjAraVariable.listStatusUser = []
        value.forEach(function (status) {
          self.researchObjAraVariable.listStatusUser.push(status.value);
        })
        break;
    }
  }

  self.validateInputAra = function () {
    self.researchObjAraVariable.offset = 0;
    self.researchObjAraVariable.limit = 10;
    self.configObj.isLoadingResearch = true;
    if (
      !self.researchObjAraVariable.piva &&
      !self.researchObjAraVariable.name &&
      !self.researchObjAraVariable.identifier &&
      !self.researchObjAraVariable.ndg &&
      !self.researchObjAraVariable.listStatusUser.length &&
      !self.researchObjAraVariable.listTypeUser.length
    ) {
      $rootScope.$broadcast("addAlert", {
        text: "LOGIN_LANDINGPAGE_003",
      });
      self.configObj.isLoadingResearch = false;
    } else {
      self.configObj.researchAraVariable = self.researchObjAraVariable;
      self.searchCustomers && self.searchCustomers()
    }
  };

  self.getEstrazioni = function () {
    var strTypeUser = self.researchObjAraVariable.listTypeUser.join()
    var strSubType = self.researchObjAraVariable.listSubtypeUser.join()
    var strStatUser = self.researchObjAraVariable.listStatusUser.join()
    var exportUser = {
      listTypeUser: strTypeUser || null,
      listSubtypeUser: strSubType || null,
      listStatusUser: strStatUser || null,
      piva: self.researchObjAraVariable.piva || null,
      name: self.researchObjAraVariable.name || null,
      ndg: self.researchObjAraVariable.ndg || null,
      identifier: self.researchObjAraVariable.identifier || null
    }
    self.isLoadingExportContracts = true
    $simulationService
      .exportGestioneUtenze(exportUser)
      .then(function (resp) {
        self.isLoadingExportContracts = false
      })
      .catch(function (err) {
        console.log(err)
        self.isLoadingExportContracts = false
      })
  }


}
